// @flow
import remote from './remote';

export function createFriendRequests(data: Object) {
  return remote.post('friendrequests', data);
}

export function getFriendRequests(query: Object = {}) {
  return remote.get('friendrequests', query);
}

export function removeFriendRequest(id: number) {
  return remote.delete(`friendrequests/${id}`);
}

export function acceptFriendRequest(userId: number, token: string) {
  return remote.post(`users/${userId}/friend`, { token });
}

export function rejectFriendRequest(userId: number, token: string) {
  return remote.post(`users/${userId}/ignore`, { token });
}
